
import React from 'react';
import { Button } from '@/components/ui/button';
import { User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useSession } from '@supabase/auth-helpers-react';

interface HeroSectionProps {
  onSOSClick: () => void;
  onAuthClick: () => void;
  playedGamesCount: number;
  maxFreeGames: number;
}

const HeroSection = ({ 
  onSOSClick, 
  onAuthClick, 
  playedGamesCount, 
  maxFreeGames 
}: HeroSectionProps) => {
  const navigate = useNavigate();
  const session = useSession();

  return (
    <div className="flex flex-col items-center justify-center space-y-8 py-12">
      {/* Hero Section */}
      <div className="text-center space-y-4 animate-fade-in">
        <h1 className="text-4xl font-bold text-gray-900">CraveSOS</h1>
        <p className="text-gray-600 max-w-md mx-auto">
          Overcome sugar cravings with quick, engaging mini-games designed to help you stay on track.
        </p>
      </div>

      <Button
        onClick={onSOSClick}
        className="bg-coral hover:bg-coral-dark text-white h-24 w-24 rounded-full text-xl font-semibold animate-sos-pulse shadow-lg hover:shadow-xl transition-all duration-300"
      >
        SOS
      </Button>
      
      {session ? (
        <div className="mt-4">
          <Button 
            variant="outline" 
            onClick={() => navigate('/profile')}
            className="flex items-center gap-2"
          >
            <User size={16} />
            View Your Progress
          </Button>
        </div>
      ) : (
        <div className="mt-4">
          <Button 
            variant="outline" 
            onClick={onAuthClick}
            className="text-sm"
          >
            Sign in to save your progress
          </Button>
          {playedGamesCount > 0 && (
            <p className="text-sm mt-2 text-gray-500">
              {playedGamesCount}/{maxFreeGames} free games played
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default HeroSection;
